import { useCallback, useState } from 'react'
import { ProductVariantCombinationsPrepared } from '../../types'
import { CreateAutoVariantsStep1 } from './Steps/FirstStep'
import { CreateVariantsSecondsStep } from '../CreateVariantsSecondStep'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { OnSubmit } from '../../../../../../../../forms/TwinForm/types'

interface CreateAutoVariantsProps extends CreateAutoVariantsLogicProps { }

const CreateAutoVariants: React.FC<CreateAutoVariantsProps> = ({ ...rest }) => {
    const { Component, combinations, onSubmitInner } = useCreateAutoVariantsLogic(rest)
    return (
        <Component onSubmit={onSubmitInner} combinations={combinations || []} />
    )
}

const ComponentsByStep = {
    1: CreateAutoVariantsStep1,
    2: CreateVariantsSecondsStep
}

interface CreateAutoVariantsLogicProps extends ModalEditComponentProps { }

const useCreateAutoVariantsLogic = ({ setOpened, onSubmit }: CreateAutoVariantsLogicProps) => {
    const [combinations, setCombinations] = useState<ProductVariantCombinationsPrepared | null>(null)
    const [step, setStep] = useState<1 | 2>(1)

    const step1Submit: OnSubmit = useCallback(async (res) => {
        const response = await res.json()
        if (response) {
            setCombinations(response)
            setStep(2)
        }
    }, [])
    const step2Submit: OnSubmit = useCallback((res, values) => {
        onSubmit(res, values)
        setOpened(null)
    }, [onSubmit, setOpened])
    
    const onSubmitInner: OnSubmit = useCallback((res, values) => {
        const submits = {
            1: step1Submit,
            2: step2Submit
        }
        submits[step](res, values)
    }, [step, step1Submit, step2Submit])

    const Component = ComponentsByStep[step]
    return { Component, setStep, combinations, setCombinations, onSubmitInner }
}

export default CreateAutoVariants